import { combineReducers } from 'redux';
import users from './index';

const appReducer = combineReducers({
  users: users,
});

export default appReducer;
